import { buildProps } from '@bigin/utils'
import type { ExtractPropTypes } from 'vue'

export const lottieProps = buildProps({
  src: {
    type: String,
    default: '',
  },
  mode: {
    type: String,
    default: 'normal',
  },
  autoplay: {
    type: Boolean,
    default: true,
  },
  loop: {
    type: Boolean,
    default: true,
  },
  controls: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 240,
  },
  height: {
    type: Number,
    default: 240,
  },
})

export type LottieProps = ExtractPropTypes<typeof lottieProps>
